import React from 'react';

interface LinkRestoreModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRestart: () => void;
}

const LinkRestoreModal: React.FC<LinkRestoreModalProps> = ({ isOpen, onClose, onRestart }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-slate-900/80 backdrop-blur-sm z-50 flex items-center justify-center p-4" 
      role="dialog" 
      aria-modal="true" 
      aria-labelledby="restore-title"
      style={{ animation: 'modal-fade-in 0.3s' }}
    >
      <div 
        className="bg-white dark:bg-slate-800 border dark:border-slate-700 rounded-lg shadow-xl w-full max-w-md p-6 text-center"
        style={{ animation: 'modal-content-pop 0.3s' }}
      >
        <h2 id="restore-title" className="text-xl font-bold text-slate-900 dark:text-white mb-4">Connection Restored</h2>
        <p className="text-gray-600 dark:text-slate-300 mb-6">
          Your internet connection is back online. Would you like to restart the speed test?
        </p>
        <div className="flex justify-center gap-4">
          <button onClick={onClose} className="px-6 py-2 bg-gray-200 dark:bg-slate-700/50 text-slate-800 dark:text-white font-semibold rounded-full hover:bg-gray-300 dark:hover:bg-slate-600/50 transition">
            Cancel
          </button>
          <button onClick={onRestart} className="px-6 py-2 bg-cyan-600 text-white font-semibold rounded-full hover:bg-cyan-500 transition">
            Restart Test
          </button>
        </div>
      </div>
    </div>
  );
};

export default LinkRestoreModal;